
/**
 * Utility functions for developer features
 */

/**
 * Checks if the current user should have access to developer features
 * Based on being in the Lovable editor environment
 */
export const hasDeveloperAccess = (userEmail?: string | null): boolean => {
  // Check if we're in the Lovable editor or preview
  const hostname = window.location.hostname;
  const isLovableEditor = hostname.includes('lovable.dev') || 
                         hostname.includes('lovableproject.com') ||
                         hostname.includes('lovable.app');
  
  console.log('Developer access check:', { 
    isLovableEditor,
    userEmail,
    hostname,
    result: isLovableEditor
  });
  
  // Grant access only if in Lovable editor environment
  return isLovableEditor;
};
